import { Navigate, useParams } from 'react-router-dom';
import Loading from '@components/Loading';
import { getQrSession, qrPath, resolveQrToken } from '@helper/qrNavigation';

const QrRouteGuard = ({ children }) => {
    const { tokenqr: routeToken } = useParams();
    const tokenqr = resolveQrToken(routeToken);
    if (!tokenqr) return <Navigate to={qrPath('', 'home')} replace />;
    if (!getQrSession(tokenqr)) {
        return <Navigate to={qrPath(tokenqr, 'home')} replace />;
    }
    return children || <Loading />;
};

export default QrRouteGuard;
